module.exports = __webpack_public_path__ + "assets/img/tx21g_1.cd5fc9ad.jpg";